import { IconName } from '@shared/components'

export interface NavItem {
  label: string
  route: string
  icon: IconName
}

export const NAV_ITEMS: NavItem[] = [
  { label: 'Home', route: '/home', icon: 'home' },
  { label: 'Muro', route: '/muro', icon: 'wall' },
  { label: 'Personas', route: '/personas', icon: 'user' },
  { label: 'Trámites', route: '/tramites', icon: 'clipboard' },
  { label: 'Noticias', route: '/noticias', icon: 'newspaper' },
  { label: 'Reconocimientos', route: '/reconocimientos', icon: 'medal' },
  { label: 'Mis documentos', route: '/mis-documentos', icon: 'folder' },
  { label: 'Encuestas', route: '/encuestas', icon: 'poll' }
]
